import { performRequest } from "./nuxtApp.js";
export function useGraphqlMutation(...args) {
  const [name, body, fetchOptions = {}] = typeof args[0] === "string" ? [args[0], args[1], args[2]?.fetchOptions] : [args[0].name, args[0].variables, args[0].fetchOptions];
  return performRequest("mutation", name, "post", {
    body,
    ...fetchOptions
  });
}
